__turbopack_context__.v({
  "Space": "styles-module__eTD7bW__Space",
  "Space--horizontal": "styles-module__eTD7bW__Space--horizontal",
  "Space--vertical": "styles-module__eTD7bW__Space--vertical",
});
